import { render, staticRenderFns } from "./UserRepo.vue?vue&type=template&id=6ac7eabb&scoped=true"
import script from "./UserRepo.vue?vue&type=script&lang=js"
export * from "./UserRepo.vue?vue&type=script&lang=js"
import style0 from "./UserRepo.vue?vue&type=style&index=0&id=6ac7eabb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7eabb",
  null
  
)

export default component.exports